import React from "react";
import { createRoot } from "react-dom/client";
import { Amplify } from "aws-amplify";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import config from "./config";
import { ColorModeProvider } from "./libs/ColorMode";
import "./index.css";

// Defensive: an earlier version of this site may have registered a service
// worker that's now intercepting requests and serving stale cached assets,
// causing "page reverts to old version" symptoms even after a hard refresh.
// Unregister any leftover SW + clear all caches, then reload once so the
// next request hits the network with no SW interception.
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => {
      if (regs.length === 0) return;
      return Promise.all(regs.map((r) => r.unregister()))
        .then(() => (typeof caches !== "undefined" ? caches.keys() : []))
        .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
        .then(() => window.location.reload());
    })
    .catch(() => {});
}

// Browser bfcache (back/forward cache) can restore a stale rendered DOM
// without re-running scripts. Reload if the page is served from bfcache.
window.addEventListener("pageshow", (event) => {
  if (event.persisted) window.location.reload();
});

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID
    }
  },
  API: {
    REST: {
      license: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      }
    }
  }
});

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ColorModeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ColorModeProvider>
  </React.StrictMode>
);
